<template>
    <div class="footer" v-if="!isSmartphoneAppMode()">
        <div class="footer-in1">
            <div class="footer-container">
                <ul class="menu-footer">
                    <li><a href="/client/policy/terms">利用規約</a></li>
                    <li><a href="/client/policy/privacy-policy">プライバシーポリシー</a></li>
                    <li><a href="/client/policy/site-policy">サイトポリシー</a></li>
                    <li><a href="/client/policy/company-info">企業情報</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-in2">
            <div class="copyright">Copyright© Bridgestone BMS Co.,Ltd. All rights Reserved.</div>
        </div>
    </div>
</template>

<script>
import {DisplayUtils} from "@/display-utils";
import {Vue} from "vue-property-decorator";
    export default class Footer extends Vue {
      /** スマポアプリからの遷移モードを返却します */
      isSmartphoneAppMode() {
        return DisplayUtils.isSmartphoneAppMode();
      }
    }
</script>


<style lang="scss" scoped>
    @import "src/common-css";

    .footer > div {
        height: 70px;
    }

    .footer {
        .footer-in1 {
            background-color: $bg-gray;
            color: $font-gray;
            .footer-container {
                padding-top: 3px;
            }
        }
        .footer-in2 {
            background-color: $bg-dark-gray;
            color: $font-white;
            font-size: 10px;
            text-align: center;
            .copyright {
                line-height: 70px;
            }
        }
    }

    // PC
    @media screen and (min-width:768px) {
        .menu-footer {
            text-align: left;
            padding: 5px 0 0 5%;
        }
    }

    // SP
    @media screen and (max-width:767px) {
        .menu-footer {
            text-align: center;
            padding: 5px 0 0 0;
        }
    }

    ul {
        padding-inline-start: 0;
    }

    .menu-footer li {
        list-style: none;
        padding-left: 0;
        margin: 10px;
        display: inline;
        position: relative;
        vertical-align: middle;
    }

    .menu-footer li a {
        color: #cccccc;
        font-size: 11px;
    }

    .menu-footer li:last-of-type {
        margin-right: 0;
    }

    .menu-footer li:last-of-type::after {
        display: none;
    }

    .menu-footer li::after {
        content: '';
        width: 1px;
        height: 100%;
        display: block;
        background-color: #696969;
        position: absolute;
        top: 0;
        right: -13px;
    }
</style>